export default __webpack_public_path__ + "static/media/myportfolio.0ef1dfd1.PNG";